import { render } from "./ImplantationView.vue?vue&type=template&id=e070a336&scoped=true"
import script from "./ImplantationView.vue?vue&type=script&lang=js"
export * from "./ImplantationView.vue?vue&type=script&lang=js"

import "./ImplantationView.vue?vue&type=style&index=0&id=e070a336&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e070a336"]])

export default __exports__